import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import { DiagnosticsPane } from 'owa-header-pane';
import { observer } from 'mobx-react';
var DiagnosticsCharm = /** @class */ (function (_super) {
    tslib_1.__extends(DiagnosticsCharm, _super);
    function DiagnosticsCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DiagnosticsCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm, { key: "diagnostic charm", icons: { iconName: "DeveloperTools" /* DeveloperTools */ }, ariaLabel: "diagnostics charm" // No need to localize as it is a DEV feature only
            , behavior: {
                paneComponent: DiagnosticsPane,
                charm: 6 /* DiagnosticsCharm */,
            } }));
    };
    DiagnosticsCharm = tslib_1.__decorate([
        observer
    ], DiagnosticsCharm);
    return DiagnosticsCharm;
}(React.Component));
export default DiagnosticsCharm;
//# sourceMappingURL=DiagnosticsCharm.js.map